export default __webpack_public_path__ + "static/media/oval.3e20f3de.svg";